import {Component, OnInit} from '@angular/core';
import { UserService } from '@app/core/services/Common/user.service';
import { LayoutService } from '@app/core/services/Common/layout.service';
import { AuthService, NotificationService } from '@app/core/services';
import { User } from '@app/shared/models/Authentication/user.model';
import { ActivatedRoute, Router } from '@angular/router';

@Component({

  selector: 'sa-login-info',
  styleUrls:['login-info.component.css'],
  templateUrl: './login-info.component.html',
})
export class LoginInfoComponent implements OnInit {

  user : User;
  items: string[] = [
    'The first choice!',
    'And another choice for you.',
    'but wait! A third!'
  ];

  constructor(
    public us: UserService,
    private authService : AuthService,
    private layoutService: LayoutService,
    private notificationService : NotificationService,
    private router: Router,
    ) {
      this.user = this.authService.currentUser;
  }

  ngOnInit() {
  }

  toggleShortcut() {
    this.layoutService.onShortcutToggle();
  }

  onHidden(): void {
    //console.log('Dropdown is hidden');
  }
  onShown(): void {
    //console.log('Dropdown is shown');
  }
  isOpenChange(): void {
    //console.log('Dropdown state is changed');
  }
  editProfile():void{
        this.router.navigate(['/profile/']);
  }
  logout(){
    this.router.navigate(["/authentication/logout"],{state:{ local: true }});
  }
  showPopup() {
    this.notificationService.smartMessageBox(
      {
        title:
          '<i class=\'fa fa-sign-out txt-color-orangeDark\'></i> Logout <span class=\'txt-color-orangeDark\'><strong>' + this.authService.currentUser.fullName + '</strong></span> ?',
        content:
          'You can improve your security further after logging out by closing this opened browser' 
      },
      ButtonPressed => {
        if (ButtonPressed == 'Yes') {
          this.logout();
        }
      }
    );
  }


}
